<!--
  详情页 - 文件柜
  props:
    id: 详情id
 -->

<template>
	<div class="v-tabs sale-team">
    <div class="head">
      <div class="total">
        当前文件数量：{{fileList.length}}
      </div>
      <div class="inline-item">
        <el-upload
          class="upload-demo"
          ref="upload"
          :action="uploadUlr"
          :data="uploadData"
          :before-upload="beforeUpload"
          :on-success="handleUpload"
          :on-error="handleUploadError"
          :on-progress="handleProgress"
          :show-file-list = "false">
          <el-button size="small" type="primary" @click="set_upload_param">文件上传</el-button>
        </el-upload>
      </div>
    </div>
    <div class="content">
      <ul class="item-list">
        <li class="item" v-for="(item,index) in fileList" :key="index" :index="index" :link="item">
          <!-- 上传进行中 -->
          <template v-if="item.progress">
            <div class="icon" :class="fileIcoPath(item)"></div>
            <div class="desc">
              <el-tooltip effect="dark" :content="item.filename" placement="top">
                <div class="title">{{formatFilename(item.filename)}}</div>
              </el-tooltip>
              <div class="progress">
                <span class="progress-bar">
                  <el-progress
                    :percentage="parsePercent(item.percent)"
                    :stroke-width = '2'
                  >
                  </el-progress>
                </span>
                <span v-if="item.error" class="progress-tip">上传失败</span>
              </div>
            </div>
            <div class="option">
              <a href="javascript:;" class="try-again" v-if="item.error" @click="tryAgainUploading(item.uid)">重试</a>
              <a href="javascript:;" class="del" @click="deleteUploading(item.uid)">删除</a>
            </div>
          </template>
          <!-- 上传成功 -->
          <template v-else> 
            <div class="icon" :class="fileIcoPath(item)"></div>
            <div class="desc">
              <el-tooltip effect="dark" :content="item.filename" placement="top">
                <div class="title">{{formatFilename(item.filename)}}</div>
              </el-tooltip>
              <div class="author" v-if="!item.id">{{item.typeStr}} 文件</div>
              <div class="author" v-else>{{item.uploadName}} {{item.uploadTime}} 上传</div>
            </div>
            <div class="size">{{item.size | formatUnit}}</div>
            <div class="option">
              <a :href="clickPreview(item)" class="view" :index="index"  v-if="isShowFile(item)" target="_blank" >预览</a>
              <a :href="getDownloadUrl(item.id, item.attachIndex)" :download="item.filename" class="download">下载</a>
              <a href="javascript:;" class="del" v-if="isSummit" @click="handleDelete(item)">删除</a>
            </div>
          </template>
        </li>
        <li class="item center" v-if="!fileList.length">暂无数据</li>
      </ul>
    </div>
	</div>
</template>

<script>
  import * as api from 'src/api'
  import { Message, MessageBox } from 'element-ui'
  import * as common from 'src/config/common-config'
  import uploadMix from 'src/config/upload-mixin'

  export default {
    mounted () {
      if (this.isUploading) {
        this.getFiles()
      }
    },
    props: {
      id: {
        type: Number
      },
      moduleName: {
        type: String
      }
    },
    data () {
      return {
        apiUrl: api.path,
        // 文件列表
        fileList: [],
        // 是否有删除权限
        isSummit: true,
        // 文件路径
        fileLink: '',
        moduleApi: common.moduleApi,
        progressPercent: 0, // 上传进度默认值
        isUploading: true, // 是否在上传中
        uploadFilesCache: [] // 加入上传队伍的文件数据，包括失败的文件
      }
    },
    mixins: [uploadMix],
    computed: {
    },
    methods: {
      parsePercent (val) { // 上传数字转换成整数
        return val ? parseInt(val, 10) : 0
      },
      beforeUpload (file) { // 选中文件后，上传前
        let isOK = this.handleBeforeUpload(file) // 上传前验证是否成功
        // 文件上传进度条，上传过程中展示上传文件
        if (isOK) {
          this.uploadFilesCache.push(file) // 将选中的文件加入缓存
          this.uploadProgress = {} // 上传的数据重置
          this.uploadProgress = { // 每个文件上传进度条的数据
            ext: file.name.replace(/.+\./, '').toLowerCase(),
            filename: file.name,
            size: file.size,
            uid: file.uid,
            progress: true,
            percent: 0,
            error: false
          }
          this.fileList.push(this.uploadProgress) // 将加入上传队列的文件添加进列表，显示在dom
        } else {
          return false
        }
      },
      // 获取文件柜列表
      getFiles () {
        const url = `/cabinetFileApi/listAjax.html`
        const params = {
          refId: this.id,
          refType: this.moduleApi[this.moduleName]
        }
        api.post(url, params, (data) => {
          this.fileList = data.result
          this.isSummit = data.isSummit
        })
      },
      handleUploadError (error, file, fileList) { // 上传失败调用
        console.error(error)
        this.fileList.forEach((item, index) => {
          if (item.uid && item.uid === file.uid) { // 将上传失败的文件的状态置为失败
            item.error = true
          }
        })
        this.fileList = JSON.parse(JSON.stringify(this.fileList)) // 重新更新dom
      },
      tryAgainUploading (uid) { // 失败的文件重新上传
        this.uploadFilesCache.forEach((item) => { // 从上传缓存中查找哪个文件失败
          if (item.uid === uid) {
            this.$refs.upload.handleStart(item) // 将失败的文件加入上传队列
            this.$refs.upload.submit() // 手动开始上传文件
          }
        })
        this.fileList.forEach((item, index) => { // 将失败的文件从列表中清除，更新dom
          if (item.uid === uid) {
            this.fileList.splice(index, 1)
          }
        })
      },
      deleteUploading (uid) { // 终止上传，删除上传中或者上传失败的文件
        MessageBox.confirm('确定删除该文件吗?', '删除确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.fileList.forEach((item, index) => { // 将删除的文件从dom中删除
            if (item.uid && item.uid === uid) {
              this.fileList.splice(index, 1)
            }
          })
          this.$refs.upload.uploadFiles.forEach((item) => {
            if (item.uid === uid) {
              this.$refs.upload.abort(item) // 终止上传进度
              item.status = 'delete'
            }
          })
          this.checkoutAllUploadSuccessful(this.$refs.upload.uploadFiles) // 验证是否全部上传完成，刷新
          if (this.isUploading) { // 所有文件上传成功才能执行刷新列表
            this.getFiles()
          }
        })
      },
      // 上传进度条
      handleProgress (event, file, fileList) {
        this.fileList.forEach((item) => { // 将上传进度实时更新进数组
          if (item.uid && item.uid === file.uid) {
            this.$set(item, 'percent', event.percent)
          }
        })
        this.fileList = JSON.parse(JSON.stringify(this.fileList)) // 更新数组后，更新dom
      },
      // 上传成功后的删除确认
      handleDelete (item) {
        let url, params
        MessageBox.confirm('确定删除该文件吗?', '删除确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (item.id) {
            url = '/cabinetFileApi/deleteAjax.html'
            params = {
              fileId: item.id
            }
          } else {
            url = '/redundantFieldApi/fileCabinet/delete.html'
            params = {
              refId: item.refId,
              refType: item.refType,
              attr: item.attr,
              fileName: item.filename
            }
          }
          this.del(url, params)
        }).catch(() => {})
      },
      // 删除
      del (url, params) {
        api.post(url, params, (data) => {
          Message({
            type: 'success',
            message: data.msg || '操作成功！'
          })
          if (this.isUploading) { // 所有文件上传成功后才能执行刷新列表
            this.getFiles()
          }
        })
      },
      // 验证是否全部上传成功
      checkoutAllUploadSuccessful (fileList) {
        this.isUploading = true
        fileList.forEach((item) => {
          if (item.status === 'uploading') {
            this.isUploading = false
          }
        })
        return this.isUploading
      },
      // 上传成功事件
      handleUpload (response, file, fileList) {
        this.checkoutAllUploadSuccessful(fileList)
        let d = new Date()
        const url = `/cabinetFileApi/saveAjax.html`
        const params = {
          refType: this.moduleApi[this.moduleName],
          refId: this.id,
          filename: file.name,
          attachIndex: this.fileUrl[file.uid],
          ext: file.name.replace(/.+\./, '').toLowerCase(),
          filesize: file.size,
          addTime: Math.floor(d.getTime() / 1000)
        }
        api.post(url, params, (data) => {
          Message({
            type: 'success',
            message: data.msg || '上传成功！'
          })
          if (this.isUploading) { // 所有文件上传成功才能执行刷新列表
            this.getFiles()
          }
        }, () => {
          this.uploadError = true
        })
      },
      // 通过后缀名获取关联图标
      fileIcoPath (file) {
        let ext
        if (file.ext) {
          ext = file.ext.toLowerCase()
        } else {
          ext = file.attachIndex.slice(file.attachIndex.lastIndexOf('.') + 1).toLowerCase()
        }
        return utils.getFileType(ext)
      },
      // 处理文件名
      formatFilename (name) {
        if (name.length > 20) {
          return name.substring(0, 10) + '...' + name.substring(name.length - 10, name.length)
        }
        return name
      },
      // 处理文件后缀为图片，txt,excel,word,pdf
      isShowFile (file) {
        let ext
        if (file.ext) {
          ext = file.ext.toLowerCase()
        } else {
          ext = file.attachIndex.slice(file.attachIndex.lastIndexOf('.') + 1).toLowerCase()
        }
        return utils.getFileViewType(ext)
      },
      // 点击预览
      clickPreview (file) {
        let reg = /attachIndex=[^&$]+/
        let fileLink
        if (reg.test(file.attachIndex)) {
          fileLink = file.attachIndex.match(reg)[0].split('=')[1]
        } else {
          fileLink = file.attachIndex
        }
        if (['office', 'pdf'].includes(this.isShowFile(file))) {
          return 'https://view.xbongbong.com/view/url?url=' + fileLink
        } else {
          return fileLink
        }
      },
      // 获取文件下载链接
      getDownloadUrl (id, defaultUrl) {
        if (id) {
          return `${this.apiUrl}/cabinetFile/loadCabinetFile.html?id=${id}`
        } else {
          return defaultUrl
        }
      }
    },
    filters: {
      // 对文件大小单位进行格式化
      formatUnit (size) {
        if (size > 999999) {
          return (size / 1024 / 1024).toFixed(2) + 'MB'
        } else if (size > 999) {
          return (size / 1024).toFixed(2) + 'KB'
        } else {
          return size + 'B'
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '../../../assets/less/variable.less';
  .sale-team {
    .head {
      border-bottom:1px dashed #e5ecf7;
    }
    .content {
      .item {
        border-bottom:1px #e5ecf7 solid;
        display: flex;
        padding: 15px 0;
        .icon {
          width: 48px;
          height: 48px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center center;
          background-image: url('../../../assets/imgs/ic_file_other.png');
          &.image {
            background-image: url('../../../assets/imgs/ic_file_image.png');
          }
          &.text {
            background-image: url('../../../assets/imgs/ic_file_text.png');
          }
          &.zip {
            background-image: url('../../../assets/imgs/ic_file_zip.png');
          }
          &.sounds {
            background-image: url('../../../assets/imgs/ic_file_sounds.png');
          }
          &.excel {
            background-image: url('../../../assets/imgs/ic_file_excel.png');
          }
          &.pdf {
            background-image: url('../../../assets/imgs/ic_file_pdf.png');
          }
          &.word {
            background-image: url('../../../assets/imgs/ic_file_word.png');
          }
          &.ppt {
            background-image: url('../../../assets/imgs/ic_file_ppt.png');
          }
          &.video {
            background-image: url('../../../assets/imgs/ic_file_video.png');
          }
          &.html {
            background-image: url('../../../assets/imgs/ic_file_html.png');
          }
        }
        .desc {
          flex: 3;
          padding: 0 10px;
          .title {
            font-size: 14px;
            line-height: 1.6;
          }
          .author {
            margin-top: 6px;
            font-size: 13px;
            color: @light-gray;
          }
          /*进度条*/
          .progress {
            .progress-bar {
              display: inline-block;
              width: 300px;
              // line-height: 2px;
              // height: 2px;
              // background: #ebeef5;
              // .progress-bar-inner {
              //   height: 100%;
              //   width: 0%;
              //   background: #409eff;
              // }
            }
            .progress-tip {
              color: @bg-red;
            }
          }
        }
        .size {
          flex: 1;
          font-size: 13px;
          line-height: 48px;
          color: @light-gray;
        }
        .option {
          min-width: 124px;
          line-height: 48px;
          text-align: right;
          .view {
            margin-right: 15px;
          }
          .download {
            margin-right: 15px;
            color: @primary;
          }
          .del {
            color: @bg-red;
          }
          .try-again {
            margin-right: 15px;
            color: @primary;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?236f33f9